import { IBasketballGameApi } from '../types';
import format from 'date-fns/format';
import Core from '@mediaplatform/basketball-sdk';
import { MarketValueTypes } from '../constants/marketValueTypes';
import { ALL, ODDS } from '../constants/statusFilters';

const DEFAULT_DATE_FORMAT = 'dd.MM.yyyy HH:mm';

export default (sdk: Core): IBasketballGameApi => {
  const getGameById: IBasketballGameApi['getGameById'] = ({
    dataMatchId,
    dataDate,
    dataOddsDisplay,
    dataOddsBettingId,
    dataOddsMarket,
    dataOddsMarketValueType,
    dataOddsPreEventOnly = false,
  }) => {
    if (dataMatchId) {
      const game = sdk.game(dataMatchId).withDateConfig({ date: dataDate?.date, dateFormat: DEFAULT_DATE_FORMAT });

      if (dataOddsDisplay) {
        game.withOdds({
          bettingId: dataOddsBettingId,
          market: dataOddsMarket,
          oddFormat: dataOddsMarketValueType,
          preEventOddsOnly: dataOddsPreEventOnly,
        });
      }

      return game.get();
    }

    return Promise.reject(new Error('Promise fail. Check your SDK options configuration.'));
  };

  const getGames: IBasketballGameApi['getGames'] = ({
    dataOddsBettingId,
    dataOddsMarket,
    dataOddsDisplay,
    dataOddsPreEventOnly = false,
    dataOddsMarketValueType,
    dateFilter,
    statusFilter = '',
    dataPopularList,
  }) => {
    const dateFormat = 'yyyy-MM-dd';
    const date = format(dateFilter, dateFormat);
    const games = sdk.games({});
    if (!games) return Promise.reject(new Error('Promise fail. Check your SDK options configuration.'));

    games.groupGamesByCompetition().withDateConfig({ date: date, dateFormat: dateFormat });

    if (dataOddsDisplay) {
      games.withOdds({
        bettingId: dataOddsBettingId || '',
        oddFormat: dataOddsMarketValueType || MarketValueTypes.DECIMAL.toUpperCase(),
        market: dataOddsMarket || '',
        preEventOddsOnly: dataOddsPreEventOnly,
      });
    }

    if (statusFilter && ![ALL, ODDS].includes(statusFilter)) {
      games.withStatusFilter({ type: statusFilter, competitionList: dataPopularList });
    }

    if (statusFilter === ODDS) {
      games.withOddsOnly(true);
    }

    return games.get();
  };

  const getSeasons: IBasketballGameApi['getSeasons'] = ({ competitionId, teamId }) => {
    if (competitionId || teamId) {
      const seasons = sdk.seasons({ competitionId: competitionId?.toString(), teamId: teamId?.toString() });

      if (!seasons) return;

      return seasons.get();
    }

    console.warn('No competition or team is provided');
  };

  return { getGameById, getGames, getSeasons };
};
